import { render, staticRenderFns } from "./coupon-table.vue?vue&type=template&id=a3684262&scoped=true&"
import script from "./coupon-table.ts?vue&type=script&lang=ts&"
export * from "./coupon-table.ts?vue&type=script&lang=ts&"
import style0 from "./coupon-table.scss?vue&type=style&index=0&id=a3684262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3684262",
  null
  
)

export default component.exports